<template>
  <div id="pdfvuer">
    <pdf
      :src="pdfdata"
      v-for="i in numPages"
      :key="i"
      :id="i"
      :page="i"
      :scale.sync="scale"
      :style="{ width: pdfWidth, margin: 'auto' }"
      :annotation="true"
      :resize="true"
      @link-clicked="handle_pdf_link"
    >
    </pdf>
    <Loader :loading="loaderLoading" :message="LoaderText"></Loader>
  </div>
</template>

<script>
//import pdf from "vue-pdf";
import pdfvuer from "pdfvuer";
import Loader from "../Loader.vue";
export default {
  name: "PDFViewer",
  data() {
    return {
      numPages: this.value,
      pdfdata: undefined,
      loaderLoading: false,
      errors: [],
      scale: "page-width",
      pdfWidth: "100%",
    };
  },
  components: {
    pdf: pdfvuer,
    Loader,
  },
  computed: {
    formattedZoom() {
      return Number.parseInt(this.scale * 100);
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
  },
  mounted() {
    this.getPdf();
  },
  props: {
    documentPath: String,
    page: { type: Number, default: 1 },
    value: Number,
    //numPages:  {type:Number, default: 0},
  },
  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if (
        (document.getElementById(p) && window.pageYOffset <= this.findPos(document.getElementById(p))) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    },
  },
  methods: {
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    getPdf() {
      this.loaderLoading = true;
      const CorruptedFileError = "CorruptedFileError.pdf";
      var self = this;
      self.pdfdata = pdfvuer.createLoadingTask(this.documentPath);
      self.pdfdata
        .then((pdf) => {
          self.numPages = pdf.numPages;
          this.$emit("input", self.numPages);
          this.loaderLoading = false;
          window.onscroll = function () {
            changePage();
            //stickyNav()
          };

          // Get the offset position of the navbar
          //var sticky = $('#buttons')[0].offsetTop

          // Add the sticky class to the self.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
          function stickyNav() {
            if (window.pageYOffset >= sticky) {
              $("#buttons")[0].classList.remove("hidden");
            } else {
              $("#buttons")[0].classList.add("hidden");
            }
          }

          function changePage() {
            var i = 1,
              count = Number(pdf.numPages);
            do {
              if (
                (document.getElementById(i) && window.pageYOffset >= self.findPos(document.getElementById(i))) &&
                document.getElementById(i + 1) && window.pageYOffset <= self.findPos(document.getElementById(i + 1))
              ) {
                //self.page = i;
                self.$emit("update:page", i);
              }
              i++;
            } while (i < count);
            if (
              document.getElementById(i) && window.pageYOffset >= self.findPos(document.getElementById(i))
            ) {
               //self.page = i;
              self.$emit("update:page", i);
            }
          }
        })
        .catch((error) => {
          //console.error(error);
          this.pdfWidth = "50%";
          self.pdfdata = pdfvuer.createLoadingTask(CorruptedFileError);
          self.pdfdata.then((pdf) => {
            self.numPages = pdf.numPages;
            this.$emit("input", self.numPages);
            this.loaderLoading = false;
          });
          // console.log(error, self)
        });
    },
    findPos(obj) {
      return obj.offsetTop;
    },
  },
};
</script>
<style src="pdfvuer/dist/pdfvuer.css"></style>
<style lang="css" scoped>
#buttons {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
/* Page content */
.content {
  padding: 16px;
}
</style>